<template>
    <rkm-modal
        @save="handleSave"
        class="rkm-modal"
        extra-large
        ref="RkmModal"
        title="Finalizar FAA"
        @hide="handleExit()"
    >
        <Form
            :data="data"
            :faaId="faaId"
            @saved="saved"
            ref="Form"
        />

        <template v-slot:footer="{ cancel }">
            <rkm-button @click="cancel">
                Fechar
            </rkm-button>

            <rkm-button
                    :disabled="flg_processando == 1"
                    color="primary"
                    small
                    title="Imprimir"
                    @click="openFile(atendimentoId)"
                >
                Visualizar atendimento
            </rkm-button>

            <rkm-button
                @click.stop="handleFinalizar"
                color="outline-success"
            >
                Finalizar atendimento
            </rkm-button>
        </template>
    </rkm-modal>
</template>

<script>
// Components.
import Form from './Form'

// Vuex
import { mapActions } from 'vuex'

// Mixin
import { repository, error, object, data, stringCase } from '@/mixins'

export default {
    components: { Form },
    created() {
        this.repositories = {
            faaImpressao: this.getConectaSusRepository('impressao.prontoAtendimento')
        }
    },
    data: () => ({
        flg_processando : 0,
        faaId: null,
        atendimentoId: null,
    }),
    methods: {
        ...mapActions(['setLoading', 'unsetLoading']),
        open(item) {

            this.setLoading()

            this.faaId = item.id
            this.atendimentoId = item.atendimentoId

            this.$refs.RkmModal.show()

            this.unsetLoading()
        },
        handleSave() {

            this.$refs.Form.save()
        },
        saved() {

            this.handleExit()
        },
        handleExit() {

            this.$refs.Form.resetModel()
            this.$refs.RkmModal.hide()
        },
        handleFinalizar() {

            this.$refs.Form.save()
        },
        unlockLoading() {
            this.flg_processando = 0
            this.unsetLoading()
        },
        openFile(atendimentoId) {
            if(this.flg_processando == 1){
                 return
            }
            this.flg_processando = 1
            this.setLoading()

            this.repositories.faaImpressao.faa.eletronica(atendimentoId)
                .then(response => {

                    const content = new Blob([response.data], { type: response.headers['content-type'] })
                    const url = URL.createObjectURL(content)
                    const link = document.createElement('a')

                    link.href = url
                    link.target = '_blank'
                    link.click()
                    link.remove()
                })
                .catch(this.handleError)
                .finally(() => this.unsetLoading())
        },
     },
    mixins: [repository, error, object, data, stringCase],
    props: {
        data: { type: Object, required: true },
    },
}
</script>